import { Grid } from "@mui/material";
import ProductCard from "./product-card";

const ProductGrid = ({ productList }) => {
  // const p = {'variant_url':'var_11-Ace-Of-Face-Foundation-Stick-07-Vanilla-Latte-Fair-Golden-Undertone-','variant_name':"Ace-Of-Face-Foundation-Stick-07-Vanilla-Latte" ,'variant_image':'https://www.sugarcosmetics.com/cdn/shop/files/Ace-Of-Face-Foundation-Stick-Kit-4.jpg?v=1746616410&width=1920'}
  
  return (

    <Grid container spacing={2}>
      {productList.map((p) => (
        <Grid size={{ xs: 6, md: 4, xl: 3, lg: 3 }}>
          <ProductCard product={p} />
        </Grid>
      ))}
    </Grid>
  );
};
export default ProductGrid;
